import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "CC_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#CC_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h32v24H0V0z",
      fill: "#5EAA22"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24 7l-1 .732.134-1.232L22 6l1.134-.5L23 4.268 24 5l1-.732-.134 1.232L26 6l-1.134.5L25 7.732 24 7zM22.963 13.678l-1 .732.134-1.232-1.134-.5 1.134-.5-.134-1.232 1 .732 1-.732-.134 1.232 1.134.5-1.134.5.134 1.232-1-.732zM26 19l-1 .732.134-1.232L24 18l1.134-.5L25 16.268 26 17l1-.732-.134 1.232L28 18l-1.134.5.134 1.232L26 19zM27 9.5l-.5.366.067-.616L26 9l.567-.25-.067-.616.5.366.5-.366-.067.616L28 9l-.567.25.067.616L27 9.5zM7 14A5 5 0 107 4a5 5 0 000 10zM19.898 14.945c-.659 1.13-1.704 1.642-3.104 1.642a3.794 3.794 0 110-7.587c1.598 0 2.873.56 3.459 2.082-.464-.459-1.18-.774-2.253-.734-1.657 0-2.734 1.29-2.734 2.395S16.343 15.35 18 15.35c.833-.013 1.449-.165 1.898-.405z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.583 8.693s-.978 3.58-1.381 3.92c-.179.079 1.618 0 1.618 0s-.673-.295-.436-.688c.237-.392.547-2.916.436-3.776-.11-.86-.237.544-.237.544z",
      fill: "#915E2B"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.791 8.826s1.048.315 1.048.85c0 .537.872 1.29.872.576 0-.713-.163-1.426-.517-1.426-.355 0 .173-.48.476-.081.303.398 1.367-.037 1.15-.317-.215-.28-.982-.627-1.109-.627-.126 0 .873-.68 0-.68-.872 0-.372.58-.963-.037-.59-.617.252.301.252-.735s-.239-1.46-1.028-.878c-.79.582-.639.213-.92-.007-.28-.219-.527.803-.218 1.012.31.209.652.726.343.726-.31 0-.528-.298-.528-.512 0-.214-.84-.591-1.64-.591-.798 0-.281.59 0 .59.282 0 1.545.431.914.431-.632 0 .048-.318-.747-.318-.796 0-1.72-.362-1.72.318 0 .68.794.982 1.043.68.248-.3.535-.81.535-.302s-.633.3-1.579.615-.674 1.145.454.942c1.129-.202 1.007-.191 1.46-.506.453-.315 1.014-.227.554.277-.46.505-.92 1.426-.46 1.426s.756.126.756-.361c0-.488.267-1.436.267-.836 0 .601.348 1.054.657.836.31-.219-.072-.903.281-.903.353 0 .367-.162.367-.162z",
      fill: "#5EAA22"
    }
  ))
);
export {
  t as default
};
